"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoAddress = AutoAddress;

var _react = _interopRequireWildcard(require("react"));

var _downshift = _interopRequireDefault(require("downshift"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var COUNTRY = '';
var TOKEN = '';
var searchedAddressesMap = [];
var ALLOW_PO;
var SearchAddressLine;
var GenerateTemporaryToken;

function stateReducer(state, changes) {
  if (changes && changes.inputValue && changes.inputValue.length >= 5) {
    if (!ALLOW_PO) {
      if (!changes.inputValue.includes('PO Box')) {
        searchAddressLine(changes.inputValue);
      }
    } else {
      searchAddressLine(changes.inputValue);
    }
  }

  if (changes.type && !changes.isOpen && state.selectedItem === null) {
    changes.inputValue = state.inputValue;
  }

  if (changes && changes.selectedItem && changes.selectedItem.AddressLine !== null && !changes.isOpen) {
    changes.inputValue = transformItem(changes.selectedItem);
    state.inputValue = changes.inputValue;
  }

  return changes;
}

function searchAddressLine(inputValue) {
  if (inputValue && inputValue.length >= 5) {
    SearchAddressLine(TOKEN, inputValue, COUNTRY).then(function (addresses) {
      if (addresses.data.DtResponse.ErrorMessage === 'Temporary Request Key has expired') {
        GenerateTemporaryToken().then(function (token) {
          TOKEN = token.data.key;
        });
        SearchAddressLine(TOKEN, inputValue, COUNTRY).then(function (addresses) {
          searchedAddressesMap = addresses.data.DtResponse.Result;
        });
      } else {
        searchedAddressesMap = addresses.data.DtResponse.Result;
      }
    });
  }

  return searchedAddressesMap;
}

var AutoAddressLabelStyle = (0, _styled["default"])('label')({
  display: 'flex',
  fontFamily: 'Roboto,sans-serif',
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '24px',
  color: '#414141',
  marginBottom: '8px'
}, function (_ref) {
  var disabled = _ref.disabled;
  return {
    opacity: disabled ? '0.5' : 'none'
  };
});
var AutoAddressPStyle = (0, _styled["default"])('p')({
  margin: '8px 0 0',
  fontFamily: 'Roboto,sans-serif',
  fontWeight: 300,
  fontSize: '14px',
  lineHeight: '20px',
  color: '#00000',
  letterSpacing: '0px',
  display: 'flex'
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return {
    opacity: disabled ? '0.5' : 'none'
  };
});
var AutoAddressErrorStyle = (0, _styled["default"])('p')({
  margin: '8px 0 0',
  fontFamily: 'Roboto,sans-serif',
  fontWeight: 300,
  fontSize: '14px',
  lineHeight: '20px',
  color: '#b3000c',
  letterSpacing: '0px',
  display: 'flex'
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return {
    opacity: disabled ? '0.5' : 'none'
  };
});
var AutoAddressStyle = (0, _styled["default"])('input')({
  width: '100%',
  height: '48px',
  fontSize: '16px',
  fontWeight: 300,
  lineHeight: '24px',
  fontFamily: 'Roboto,sans-serif',
  color: '#000000',
  border: 'none',
  padding: '0 16px',
  boxSizing: 'border-box',
  '&:focus': {
    outline: 0,
    borderRadius: '1px !important',
    boxShadow: '0 0 0px 4px #82c6ff !important'
  }
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return {
    opacity: disabled ? '0.5' : 'none',
    backgroundColor: disabled ? '#f2f2f2' : 'none'
  };
}, function (_ref5) {
  var autoCompleteFieldColor = _ref5.autoCompleteFieldColor;
  return {
    backgroundColor: autoCompleteFieldColor ? autoCompleteFieldColor : 'none'
  };
}, function (_ref6) {
  var autoAddressError = _ref6.autoAddressError;
  return {
    borderBottom: autoAddressError ? '4px solid #b3000c' : ''
  };
});
var Menu = (0, _styled["default"])('ul')({
  padding: 0,
  marginTop: '-28px',
  position: 'absolute',
  width: '100%',
  overflowY: 'auto',
  overflowX: 'hidden',
  outline: '0',
  transition: 'opacity .1s ease',
  borderRadius: '0 0 .28571429rem .28571429rem',
  boxShadow: '0 2px 3px 0 rgba(34,36,38,.15)',
  borderColor: '#96c8da',
  borderTopWidth: '0',
  borderRightWidth: 1,
  borderBottomWidth: 1,
  borderLeftWidth: 1,
  borderStyle: 'solid',
  zIndex: 2000
}, function (_ref7) {
  var isOpen = _ref7.isOpen;
  return {
    border: isOpen ? null : 'none'
  };
}, function (_ref8) {
  var allowPO = _ref8.allowPO;
  return {
    marginTop: allowPO ? '-7px' : '-27px'
  };
});
var Item = (0, _styled["default"])('li')({
  position: 'relative',
  cursor: 'pointer',
  display: 'block',
  border: 'none',
  height: 'auto',
  textAlign: 'left',
  borderTop: 'none',
  lineHeight: '1em',
  color: 'rgba(0,0,0,.87)',
  fontSize: '1rem',
  textTransform: 'none',
  boxShadow: 'none',
  padding: '16px',
  whiteSpace: 'normal',
  wordWrap: 'normal',
  borderBottom: '1px solid #d6d6d6'
}, function (_ref9) {
  var isSelected = _ref9.isSelected;
  return {
    color: 'rgba(0,0,0,.95)',
    backgroundColor: isSelected ? '#d0e9ff' : '#ffffff'
  };
});

function transformItem(item) {
  return item.AddressLine + ', ' + item.Locality + ' ' + item.State + ' ' + item.Postcode + ' ' + item.Country;
}

function transformInitialValueItem(values, country, countryName) {
  var _values$autoAddress, _values$autoAddress2, _values$autoAddress$S, _values$autoAddress3, _values$autoAddress4, _values$autoAddress$T, _values$autoAddress5, _values$autoAddress6;

  return "".concat(values.autoAddress.AddressLine ? "".concat((_values$autoAddress = values.autoAddress) === null || _values$autoAddress === void 0 ? void 0 : _values$autoAddress.AddressLine, ", ").concat(country === 'AU' ? (_values$autoAddress2 = values.autoAddress) === null || _values$autoAddress2 === void 0 ? void 0 : _values$autoAddress2.Locality : (_values$autoAddress$S = (_values$autoAddress3 = values.autoAddress) === null || _values$autoAddress3 === void 0 ? void 0 : _values$autoAddress3.Suburb) !== null && _values$autoAddress$S !== void 0 ? _values$autoAddress$S : '', " ").concat(country === 'AU' ? (_values$autoAddress4 = values.autoAddress) === null || _values$autoAddress4 === void 0 ? void 0 : _values$autoAddress4.State : (_values$autoAddress$T = (_values$autoAddress5 = values.autoAddress) === null || _values$autoAddress5 === void 0 ? void 0 : _values$autoAddress5.TownCityMailtown) !== null && _values$autoAddress$T !== void 0 ? _values$autoAddress$T : '', " ").concat((_values$autoAddress6 = values.autoAddress) === null || _values$autoAddress6 === void 0 ? void 0 : _values$autoAddress6.Postcode, " ").concat(countryName) : '');
}

function AutoAddress(props) {
  var name = props.name,
      values = props.values,
      label = props.label,
      allowPO = props.allowPO,
      testId = props.testId,
      disabled = props.disabled,
      onSelect = props.onSelect,
      generateTemporaryToken = props.generateTemporaryToken,
      searchAddresses = props.searchAddresses,
      country = props.country,
      autoAddressError = props.autoAddressError,
      autoAddressErrorMessage = props.autoAddressErrorMessage,
      autoAddressPlaceholder = props.autoAddressPlaceholder,
      helpText = props.helpText,
      autoCompleteFieldColor = props.autoCompleteFieldColor;
  ALLOW_PO = allowPO;
  SearchAddressLine = searchAddresses;
  GenerateTemporaryToken = generateTemporaryToken;
  COUNTRY = country;
  var errorMessage = autoAddressErrorMessage !== null && autoAddressErrorMessage !== void 0 ? autoAddressErrorMessage : 'Please enter a valid address';
  var countryName = country === 'AU' ? 'Australia' : 'New Zealand';
  (0, _react.useEffect)(function () {
    generateTemporaryToken().then(function (token) {
      TOKEN = token.data.key;
    });
  }, []);

  if (values.autoAddress === undefined) {
    values.autoAddress = {};
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": testId
  }, /*#__PURE__*/_react["default"].createElement(_downshift["default"], {
    stateReducer: stateReducer,
    itemToString: function itemToString(item) {
      return item ? transformItem(item) : '';
    },
    onSelect: onSelect,
    initialInputValue: transformInitialValueItem(values, country, countryName)
  }, function (_ref10) {
    var getInputProps = _ref10.getInputProps,
        getItemProps = _ref10.getItemProps,
        getLabelProps = _ref10.getLabelProps,
        getMenuProps = _ref10.getMenuProps,
        isOpen = _ref10.isOpen,
        inputValue = _ref10.inputValue,
        highlightedIndex = _ref10.highlightedIndex,
        selectedItem = _ref10.selectedItem;
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(AutoAddressLabelStyle, {
      disabled: disabled
    }, label), /*#__PURE__*/_react["default"].createElement(AutoAddressStyle, _extends({
      name: name
    }, getInputProps(), {
      disabled: disabled,
      autoCompleteFieldColor: autoCompleteFieldColor,
      autoAddressError: autoAddressError,
      className: autoAddressError ? 'error' : '',
      placeholder: autoAddressPlaceholder !== null && autoAddressPlaceholder !== void 0 ? autoAddressPlaceholder : 'Start typing your address'
    })), autoAddressError && /*#__PURE__*/_react["default"].createElement(AutoAddressErrorStyle, {
      disabled: disabled
    }, errorMessage), /*#__PURE__*/_react["default"].createElement(AutoAddressPStyle, {
      disabled: disabled
    }, helpText), /*#__PURE__*/_react["default"].createElement(Menu, _extends({}, getMenuProps(), {
      isOpen: isOpen,
      allowPO: allowPO
    }), isOpen ? searchedAddressesMap.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement(Item, _extends({
        isSelected: highlightedIndex === index
      }, getItemProps({
        key: item.RecordId,
        index: index,
        item: item
      })), item.AddressLine, ",", ' ', item.Locality, ' ', item.State, ' ', item.Postcode, ' ', item.Country);
    }) : null));
  }));
}